import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { database, ref, get } from '../firebase/config';

const ApplyWithMobile = () => {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (mobile.length !== 10) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }
    
    if (password.length < 4) {
      setError('Password must be at least 4 characters');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Check if mobile number already exists by directly checking the path
      const applicationRef = ref(database, `applications/${mobile}`);
      const snapshot = await get(applicationRef);
      
      if (snapshot.exists()) {
        // Mobile number already has an application
        setError('You have already applied for a loan. Please check your status.');
        setTimeout(() => {
          navigate('/check-status');
        }, 2000);
      } else {
        // Proceed to application form
        navigate('/application-form', { state: { mobile, password } });
      }
    } catch (error) {
      console.error('Error checking mobile:', error);
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <div className="auth-card">
          <h2>Apply for Loan</h2>
          <p className="auth-subtitle">Enter your mobile number and create a password</p>
          
          {error && <div className="error-message">{error}</div>}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                placeholder="Enter 10-digit mobile number"
                required
              />
            </div>
            
            <div className="form-group">
              <label>Create Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Min 4 characters"
                required
              />
              <small>Use this password to check your application status later</small>
            </div>
            
            <button type="submit" className="btn-auth" disabled={loading}>
              {loading ? 'Checking...' : 'Continue to Application →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ApplyWithMobile;